/**
 * platform_csm_service.js
 *
 * Service frontend para chamar as Cloud Functions callables de CS (Customer Success).
 * Todas as chamadas são feitas via httpsCallable na região southamerica-east1.
 */

import { httpsCallable, getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getApp } from "firebase/app";
import "./firebase"; // garante que o firebase foi inicializado

const platformFunctions = getFunctions(getApp(), "southamerica-east1");

if (process.env.REACT_APP_USE_EMULATOR === "true") {
    try {
        connectFunctionsEmulator(platformFunctions, "127.0.0.1", 5001);
    } catch (e) {
        // Ignora erro se já estiver conectado
    }
}

/**
 * Atribui um Customer Success Manager (CSM) ao tenant.
 */
export const assignCsm = async ({ idTenant, csmUid, csmName }) => {
    const fn = httpsCallable(platformFunctions, "platformAssignCsm");
    const result = await fn({ idTenant, csmUid, csmName });
    return result.data;
};

/**
 * Transfere um cliente para outro CSM, justificando o motivo.
 */
export const transferCsm = async ({ idTenant, newCsmUid, newCsmName, reason }) => {
    const fn = httpsCallable(platformFunctions, "platformTransferCsm");
    const result = await fn({ idTenant, newCsmUid, newCsmName, reason });
    return result.data;
};

/**
 * Lista a carteira de clientes atribuída a um CSM ou Consultor.
 */
export const listPortfolio = async ({ userId = null, view = "csm" } = {}) => {
    const fn = httpsCallable(platformFunctions, "platformListPortfolio");
    const result = await fn({ userId, view });
    return result.data;
};

/**
 * Calcula e atualiza o Health Score de um cliente específico.
 */
export const getClientHealth = async (idTenant) => {
    const fn = httpsCallable(platformFunctions, "platformGetClientHealth");
    const result = await fn({ idTenant });
    return result.data;
};
